export default __webpack_public_path__ + "static/media/c3.9fba434e.jfif";